module.exports = __webpack_public_path__ + "img/nodata.815507b0.png";